
import { Link } from "react-router-dom";
import MobileFooter from "./MobileFooter";

const Footer = () => {
  return (
    <>
      {/* Desktop Footer */}
      <footer className="hidden lg:block bg-gradient-to-b from-juv-cream-white to-juv-soft-blush/50 pt-20 pb-8">
        <div className="container mx-auto px-6 max-w-7xl">
          <div className="grid lg:grid-cols-4 gap-12 mb-16">
            {/* Brand Column */}
            <div className="lg:col-span-1">
              <h2 className="text-2xl font-serif text-juv-deep-chestnut mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
                JUV Medspa<sup className="text-sm">™</sup>
              </h2>
              <p className="text-juv-deep-chestnut/70 leading-relaxed mb-6">
                Not your average medspa. We're redefining beauty with treatments that work, memberships that matter, and results that last.
              </p>
              <div className="flex space-x-4">
                <a href="https://instagram.com/juv.aesthetics" target="_blank" rel="noopener noreferrer" 
                   className="text-juv-terracotta hover:text-juv-deep-chestnut transition-colors duration-200">
                  <span className="sr-only">Instagram</span>
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987s11.987-5.367 11.987-11.987C24.004 5.367 18.637.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.344-1.297L12.017 8.78l6.912 6.911c-.896.807-2.047 1.297-3.344 1.297H8.449z"/>
                  </svg>
                </a>
                <a href="https://tiktok.com/@juvstudio" target="_blank" rel="noopener noreferrer"
                   className="text-juv-terracotta hover:text-juv-deep-chestnut transition-colors duration-200">
                  <span className="sr-only">TikTok</span>
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Services Column */}
            <div>
              <h3 className="text-lg font-semibold text-juv-deep-chestnut mb-6">Signature Treatments</h3>
              <ul className="space-y-3">
                <li><Link to="/treatments/botox" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">Botox</Link></li>
                <li><Link to="/treatments/lip-filler" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">Lip Filler</Link></li>
                <li><Link to="/treatments/hydrafacial" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">HydraFacial</Link></li>
                <li><Link to="/treatments/prf" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">PRF Treatment</Link></li>
                <li><Link to="/treatments" className="text-juv-terracotta font-medium">View All Treatments</Link></li>
              </ul>
            </div>

            {/* Company Column */}
            <div>
              <h3 className="text-lg font-semibold text-juv-deep-chestnut mb-6">Company</h3>
              <ul className="space-y-3">
                <li><Link to="/about" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">About Us</Link></li>
                <li><Link to="/team" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">Our Team</Link></li>
                <li><Link to="/careers" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">Careers</Link></li>
                <li><Link to="/partner" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">Partner With Us</Link></li>
                <li><Link to="/blog" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">Blog</Link></li>
              </ul>
            </div>

            {/* Support Column */}
            <div>
              <h3 className="text-lg font-semibold text-juv-deep-chestnut mb-6">Support</h3>
              <ul className="space-y-3">
                <li><Link to="/contact" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">Contact Us</Link></li>
                <li><Link to="/faqs" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">FAQs</Link></li>
                <li><Link to="/financing" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">Financing</Link></li>
                <li><Link to="/gift-card" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">Gift Cards</Link></li>
                <li><Link to="/refer" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">Refer Friends</Link></li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-juv-rose-clay/30 pt-8">
            <div className="flex flex-col lg:flex-row justify-between items-center">
              <p className="text-juv-deep-chestnut/70 text-sm mb-4 lg:mb-0">
                © 2025 JUV Medspa. All rights reserved.
              </p>
              <div className="flex space-x-6 text-sm">
                <Link to="/terms" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">Terms of Service</Link>
                <Link to="/privacy" className="text-juv-deep-chestnut/70 hover:text-juv-terracotta transition-colors duration-200">Privacy Policy</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Mobile Footer */}
      <MobileFooter />
    </>
  );
};

export default Footer;
